<template>


    <section class="">
       asam;sas
    </section>

</template>

<script>
    export default {
        name: "profile"
    }
</script>

<style scoped>

</style>